import {useContext} from 'react';
import {AppContext} from '../../../../clients/react-app/AppContext';
import {Config_common} from '../../../core/entry-point/Config_common';

export function useControllers(): Config_common['controllers'] {
    return useContext(AppContext).controllers;
}
